import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKulturpunkt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 20.174 24.047",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "K",
		transform: "translate(10)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_18",
				"data-name": "Rectangle 18",
				width: 4.368,
				height: 24.047,
				transform: "translate(-9.484)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2",
				"data-name": "Path 2",
				d: "M-4746.584,3067l-8.686,11.834,7.03,12.116h-5.2l-7.245-12.116,8.616-11.834Z",
				transform: "translate(4756.243 -3066.946)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_19",
				"data-name": "Rectangle 19",
				width: 4.368,
				height: 24.047,
				transform: "translate(-10)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12",
				"data-name": "Path 12",
				d: "M-4746.584,3067l-8.686,11.834,7.03,12.116h-5.2l-7.245-12.116,8.616-11.834Z",
				transform: "translate(4756.758 -3066.946)"
			})
		]
	})
});
export default SvgKulturpunkt;
